<template>
    <div id="header-bar" :class="['top',{'about-top': currentPath},{'h5-top': isH5}]" :style="{background: `rgba(255,255,255, ${currentPath ? 1 : getScroll()})`}">
        <img :class="['logo-bg',{'footer-logo' :getScroll() > 0.5  ||  currentPath}]" :src="getScroll() > 0.5  ||  currentPath ? logoTwo : logoOne"/>
        <div class="tab tab-pc">
            <!-- <div :class="['tab-li',{'scroll-tab': getScroll() > 0.5 ||  currentPath}]" v-for="item in tabList" :key="item.id" @click="changeTab(item)">
                <a :href="`#${item.id}`">
                    <div class="tab-name" >{{ item.title }}</div>
                    <div v-if="actived == item.id" class="bar"></div>
                </a>
            </div> -->
        <el-menu
          mode="horizontal"
          :default-active="actived"
          :ellipsis="false"
          :router="true"
          :class="['tab-li',{'scroll-tab': getScroll() > 0.5 ||  currentPath}]"
        >
        <!--           @select="changeRouter" -->
          <template v-for="item in tabList">
          <el-menu-item :index="item.path" v-if="!item.children" :key="item.id" @click="changeRouter(item.id)">
            <span class="menu-title">{{ item.text }}</span>
            <div class="bar"></div>
          </el-menu-item>
          <el-sub-menu :index="item.path" v-else :key="item.id">
            <template #title>
              <div class="sub-menu">
                <span  class="menu-title">{{ item.text }}</span>
                <div class="bar"></div>
              </div>
            </template>
            <el-menu-item :index="el.path" v-for="el in item.children" :key="el.id" @click="changeRouter(el.id)">
              <span :class="['menu-title', {'actived-sub': currentId == el.id}]">{{ el.text }}</span>
              <div class="bar"></div>
            </el-menu-item>
          </el-sub-menu>
          </template>
        </el-menu>
        </div>

        <!-- <div class="tab tab-h5" v-if="!tabNavStatus">
            <img class="more-icon" @click="changeH5Tab" :src="getScroll() > 0.5  ||  currentPath ? h5LogoTwo : h5LogoOne"/>
        </div>
        <div class="tab-h5 h5-nav-list" v-if="tabNavStatus">
            <div class="nav-list-top">
                <img class="logo-bg footer-logo" :src="logoTwo"/>
                <img class="more-icon" @click="changeH5Tab" :src="h5LogoTwo"/>
            </div>
              <van-collapse v-model="h5Actived" :border="false">
                <van-collapse-item v-for="(item, index) in tabList" :key="index" :title="item.text" :name="item.id">
                  <template #title>
                    <div :class="{'h5-sctived-path': currentId == item.id}"  @click="changeCollapse(item)">{{ item.text }}</div>
                  </template>
                  <div :class="['item-li',{'h5-sctived-path': currentId == el.id}]" v-for="(el, elIndex) in item.children" :key="elIndex" :title="el.text" :name="item.id" @click.stop="changeCollapse(el)">{{ el.text }}</div>
                  <template #right-icon>
                    <van-icon :name="item.children ? 'arrow' : ''" />
                  </template>
                </van-collapse-item>
              </van-collapse>
        </div> -->
        <div class="tab-h5" v-if="isH5">
          <van-tabs @change="changeRouter">
            <van-tab v-for="(item, index) in tabList" :key="index" :name="item.id">
              <template #title>
                <div v-if="!item.children">{{ item.text }}</div>
                <template v-else>
                  <van-popover
                    v-model="showPopover"
                    trigger="click"
                    :actions="item.children"
                    @select="selectChild"
                    :class="['tab-child-popover', 'tab-child-'+currentId]"
                  >
                    <template #reference>
                      <span >{{ item.text }}</span>
                    </template>
                  </van-popover>
                </template>
              </template>
            </van-tab>
          </van-tabs>
        </div>
    </div>
</template>

<script>
import TabH5 from "./TabList.vue"
export default {
    props: ['scroll','scrollActived'],
    data() {
        return {
            activeId: '2',
            activeIndex: 1,
            tabList: [
              { id: '1', text: "首页", path: "/home", h5Id: "1" },
              {
                id: '2',
                text: "香港身份",
                path: "/identity",
                h5Id: "identity",
                children: [
                  { text: "香港高才", id: '2-1', path: '/identity', actived: false, jsonPath:'https://borunfuture.oss-cn-hangzhou.aliyuncs.com/detail/HongKongHighTalents.json' },
                  { text: "香港优才", id: '2-2', path: '/identity', actived: false, jsonPath: 'https://borunfuture.oss-cn-hangzhou.aliyuncs.com/detail/HongKongTalents.json' },
                  { text: "香港专才", id: '2-3', path: '/identity', actived: false, jsonPath: 'https://borunfuture.oss-cn-hangzhou.aliyuncs.com/detail/HongKongProfessionals.json' },
                  { text: "企业家自雇移民", id: '2-4', path: '/identity', actived: false, jsonPath: 'https://borunfuture.oss-cn-hangzhou.aliyuncs.com/detail/SelfEmployedImmigration.json' },
                  { text: "投资移民", id: '2-5', path: '/identity', actived: false, jsonPath: 'https://borunfuture.oss-cn-hangzhou.aliyuncs.com/detail/InvestmentImmigration.json' },
                  { text: "香港留学移民", id: '2-6', path: '/identity', actived: false, jsonPath: 'https://borunfuture.oss-cn-hangzhou.aliyuncs.com/detail/IANG.json'  },
                  { text: "非本地毕业生留港/回港就业", id: '2-7', path: '/identity', actived: false, jsonPath: 'https://borunfuture.oss-cn-hangzhou.aliyuncs.com/detail/NonlocalGraduates.json' }
                ]
              },
              {
                id: '3',
                text: "教育升学",
                path: "/education",
                h5Id: "educationH5",
                jsonPath: 'https://borunfuture.oss-cn-hangzhou.aliyuncs.com/detail/Education.json'
                // children: [
                //   { text: "香港夏令营/冬令营/学术背景提升", id: '3-1', path: '/education', jsonPath: 'https://borunfuture.oss-cn-hangzhou.aliyuncs.com/detail/HongKongSummerCamp.json' },
                //   { text: "香港插班", id: '3-2', path: '/education', jsonPath: 'https://borunfuture.oss-cn-hangzhou.aliyuncs.com/detail/TransfertoHongKong.json' },
                //   { text: "香港本地大学升学", id: '3-3', path: '/education', jsonPath: 'https://borunfuture.oss-cn-hangzhou.aliyuncs.com/detail/LocalFurtherStudies.json' },
                //   { text: "内地升学", id: '3-4', path: '/education', jsonPath: 'https://borunfuture.oss-cn-hangzhou.aliyuncs.com/detail/MainlandFurtherStudies.json' }
                // ]
              },
              {
                id: '4',
                text: "企业营商",
                path: "/enterprise",
                h5Id: "enterpriseH5",
                jsonPath: 'https://borunfuture.oss-cn-hangzhou.aliyuncs.com/detail/EnterpriseBusiness.json'
              },
              {
                id: '5',
                text: "投资理财",
                path: "/invest",
                h5Id: "investH5",
                jsonPath: 'https://borunfuture.oss-cn-hangzhou.aliyuncs.com/detail/InvestmentFinancing.json'
              },
              {
                id: '6',
                text: "医疗服务",
                path: "/medical",
                h5Id: "medicalH5",
                jsonPath: 'https://borunfuture.oss-cn-hangzhou.aliyuncs.com/detail/MedicalTreatment.json'
              },
              { id: '7', text: "关于我们", path: "/about", h5Id: "7",  h5Id: "aboutH5" },
              { id: '8', text: "联系我们", path: "/contact", h5Id: "8", h5Id: "contactH5" }
            ],
            logoOne: require('@/assets/new_logo.png'),
            logoTwo: require('@/assets/new_logo.png'),
            h5LogoOne: require('@/assets/more-h5.svg'),
            h5LogoTwo: require('@/assets/moer-actived.svg'),
            tabNavStatus: false,
            actived: '/home',
            h5Actived: [],
            currentId: '1',
        }
    },
    computed:{
      currentPath() {
        return this.$route.path != '/home' && this.$route.path != '/'
      },
      isH5() {
        return window.innerWidth < 1024
      }
    },
    watch: {
        $route: {
            handler() {
              this.actived = this.$route.path
              if(localStorage.getItem('currentPath')) {
                this.currentId = JSON.parse(localStorage.getItem('currentPath')).id
              }
              
            },
            deep: true,
            immediate: true
        },
        scrollActived: {
            handler() {
                if(this.scrollActived == '') return
                this.scrollChangeTab(this.scrollActived)
            },
            deep: true,
            immediate: true
        },
    },
    components: {TabH5},
    mounted() {
      if(localStorage.getItem('currentPath')) {
        let current = JSON.parse(localStorage.getItem('currentPath'))
        this.$router.push({
          path: current.path
        })
      }
    },
    methods: {
        changeTab(item) {
            this.tabNavStatus = false
            this.$router.replace(item.path)
            window.scrollTo({top:0})
        },
        changeNav(index) {
          this.activeId = this.tabList[index].id
          this.activeIndex = index
        },
        changeRouter(id) {
          if(id == 2) {
            return
          }
          let current
          this.tabList.map(item=>{
            if(item.id == id) {
              current = item
            }
            item.children?.map(el=>{
              if(el.id == id) {
                current = el
              }
            })
          })
          this.$nextTick(()=>{
            this.actived = current.path
            window.scrollTo({top:0})
          })
          this.currentId = current.id
          localStorage.setItem('currentPath', JSON.stringify(current))
          this.$emitter.emit('changeHeaderRouter', current);
          if(this.isH5 && (current.id != 2)) {
            this.$router.push({ path: current.path })
          }
        },
        selectChild(action) {
          this.changeRouter(action.id)
        },
        getScroll() {
          if(window.innerWidth < 1024) {
            return 1
          }
            let height = Number(this.scroll)

            let opt = 1 - height / 60
            if(height > 60) {
                return 1
            }
            if (opt < 0.1) {
                return 1
            }
            return 1 - opt
        },
        changeH5Tab() {
            this.tabNavStatus = !this.tabNavStatus 
        },
        scrollChangeTab(hash) {
            for(let i = 0; i < this.tabList.length; i++) {
                if(hash == this.tabList[i].id || hash == this.tabList[i].h5Id) {
                    hash == this.tabList[i].id ? this.actived = this.tabList[i].id : this.actived = this.tabList[i].h5Id
                }
            }

        },
        changeCollapse(item) {
          if(item.children) {
            return
          }
          this.tabNavStatus = !this.tabNavStatus
          this.$router.push({path: item.path})
          this.$nextTick(()=>{
            window.scrollTo({top:0})
          })
          localStorage.setItem('currentPath', JSON.stringify(item))

          this.currentId = item.id
          this.$emitter.emit('changeHeaderRouter', item);
        }
    }
}
</script>
<style  lang="scss">
.el-menu--popup {
  width: 140Px;
  min-width: unset!important;
  .el-menu-item {
    height: 52Px!important;
    line-height: 18Px!important;
    justify-content: center;
    .menu-title {
      width: 110Px;
      height: 52Px;
      font-size: 12Px;
      color: #999999;
      display: flex;
      align-items: center;
      text-align: left;
      white-space: pre-wrap;
    }
    &:hover {
      background: rgba(176, 152, 80, 1)!important;
      .menu-title {
        color: #fff!important;
      }
    }
    .actived-sub {
      color: rgba(176, 152, 80, 1)
    }
  }
}
</style>
<style scoped lang="scss">
.top {
    position: fixed;
    z-index: 10;
    width: 100%;
    height: 62Px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: rgba(255,255,255,0);
    border-bottom: 1Px solid rgba(255,255,255,0.18);
    overflow: hidden;
}
.about-top {
    background: rgba(255,255,255,1);
    .icon-li-h5 div {
        background: #AA934D!important;
    }
}
.logo-bg {
    width: 120Px;
    // height: 40Px;
    margin-top: 4Px;
    padding-left: 114Px;
}
.footer-logo {
    width: 120Px!important;
    height: unset!important;
    // margin-left: -60Px!important;
    margin-top: 4Px;
}
.tab {
    display: flex;
    align-items: center;
    padding: 0 114Px;
}
.bar {
    height: 1Px;
    background: #fff;
}
.tab-li {
    font-size: 14Px;
    font-weight: bold;
    color: #FFFFFF;
    padding-left: 40Px;
    background: unset;
    cursor: pointer;
    a {
        text-decoration: unset;
        color: #fff;
    }
    a:hover, a:visited, a:link, a:active {
        color: #fff;
    }
}
::v-deep {
  .el-menu--horizontal.el-menu {
    height: 62Px;
    border: none;
  }
  .el-menu--horizontal>.el-menu-item, .el-menu--horizontal>.el-sub-menu .el-sub-menu__title {
    font-size: 14Px;
    font-weight: 400;
    color: #fff;
    border: none;
    display: flex;
    flex-direction: column;
  }
  .el-menu--horizontal .el-menu-item:not(.is-disabled):focus, .el-menu--horizontal .el-menu-item:not(.is-disabled):hover, .el-menu--horizontal>.el-sub-menu .el-sub-menu__title:hover {
      background: unset;
      color: rgba(176, 152, 80, 1);
  }
  .el-menu--horizontal>.el-menu-item.is-active, .el-menu--horizontal>.el-sub-menu.is-active .el-sub-menu__title {
    color: rgba(176, 152, 80, 1)!important;
    border: none;
    transition: none;
    .bar {
      display: block;
    }
  }
}
.sub-menu {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.menu-title {
  height: 62Px;
}
.bar {
  position: relative;
  top: 0Px;
  display: none;
  width: 30Px;
  height: 1Px;
  background: #b09850;
}
.scroll-tab {
  ::v-deep {
    .el-menu-item,.el-sub-menu .el-sub-menu__title {
      color:rgba(153, 153, 153, 1);
    } 
  }
}
.tab-li .tab-name {
    padding: 22Px 0 21Px;
}
.scroll-tab {
    a {
        color: #AA934D!important
    }
    a:hover, a:visited, a:link, a:active {
        color: #AA934D!important
    }
}
.scroll-tab .bar {
    height: 1Px;
    background: #AA934D;
}
.tab-pc {
    display: flex;
}
.tab-h5 {
    display: none;
}
@include pc1024() {
  .top {
    min-width: 1190Px;
    width: 1190Px;
  }
}
@include h5() {
    .h5-top {
        position: fixed;
        z-index: 101;
        height: 180px;
        border: none;
        overflow: hidden;
        .logo-bg {
            width: 181px;
            height: 59px;
        }
        .footer-logo {
            width: 180px!important;
            height: unset!important;
            margin-left: 0px!important;
            margin-top: -70px;
        }
    }
    .tab-pc {
        display: none;
    }
    .tab-h5 {
        width: 100%;
        position: absolute;
        bottom: 0;
        height: 80px;
        display: block;
        .more-icon {
            width: 120px;
            height: 120px;
            margin: 16px -30px 0 0;
        }
    }
    .tab-icon {
        margin-top: 16px;
    }
    .icon-li {
        display: flex;
        div:first-child {
            width: 4px;
            height: 4px;
            background: #FFFFFF;
            border-radius: 50%;
            margin: 0 4px 12px 0;
        }
        div:last-child {
            width: 36px;
            height: 3px;
            background: #FFFFFF;
        }
    }
    .icon-li-h5 div {
        background: #AA934D!important;
    }
    .logo-bg {
        padding-left: 24px;
    }
    .tab {
        padding: 0 24px;
    }
    .tab-name {
        font-size: 30px;
        line-height: 40px;
        padding: 24px 0 23px!important;
    }
    .tab-li:last-child {
        padding-left: 0px;
    }
    .h5-nav-list {
        position: fixed;
        top: 0;
        background: #fff;
        width: 100%;
        height:100%;
        overflow: hidden;
        text-align: center;
        .nav-list-top{
            display: flex;
            justify-content: space-between;
            margin-top: -20px;
            .footer-logo {
                margin-top: -126px;
            }
            .more-icon {
                margin: 8px -6px 0 0;
            }
        }
        .tab-list {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            margin-top: -100px;
            overflow-x: auto;
        }
        .scroll-tab {
            width: 150px;
            a {
                color: #AA934D!important;
                text-decoration: unset;
            }
            a:hover, a:visited, a:link, a:active {
                color: #AA934D!important
            }
        }
    }
    .tab-child-popover {
      ::v-deep {
        .van-popover__action {
          width: 300px;
          text-align: center;
        }
        .van-popover__arrow {
          display: none;
        }
        .van-popover__content {
          padding: 10px 0;
        }
      }
      .h5-child {
        width: 220px;
        text-align: center;
        padding: 20px 32px;
        // font-size: 28px;
      }
      .actived-h5-child {
        color: #AA934D;
      }
    }
    .tab-child-2-1 {
      ::v-deep {
        .van-popover__action:nth-child(1) {
          .van-popover__action-text {
            color: #AA934D;
          }
        }
      }
    }
    .tab-child-2-2 {
      ::v-deep {
        .van-popover__action:nth-child(2) {
          .van-popover__action-text {
            color: #AA934D;
          }
        }
      }
    }
    .tab-child-2-3 {
      ::v-deep {
        .van-popover__action:nth-child(3) {
          .van-popover__action-text {
            color: #AA934D;
          }
        }
      }
    }
    .tab-child-2-4 {
      ::v-deep {
        .van-popover__action:nth-child(4) {
          .van-popover__action-text {
            color: #AA934D;
          }
        }
      }
    }
    .tab-child-2-5 {
      ::v-deep {
        .van-popover__action:nth-child(5) {
          .van-popover__action-text {
            color: #AA934D;
          }
        }
      }
    }
    .tab-child-2-6 {
      ::v-deep {
        .van-popover__action:nth-child(6) {
          .van-popover__action-text {
            color: #AA934D;
          }
        }
      }
    }
    .tab-child-2-7 {
      ::v-deep {
        .van-popover__action:nth-child(7) {
          .van-popover__action-text {
            color: #AA934D;
          }
        }
      }
    }
    ::v-deep {
      .van-collapse {
        margin-top: -40px;
        height: 80vh;
        overflow: auto;
      }
      .van-collapse-item__content {
        padding: 0 30px 0 0;
      }
      .van-cell {
        .van-icon {
          width: 28px;
          line-height: 48px;
        }
      }
      .van-cell__title {
        height: 48px;
        line-height: 48px;
      }
      .van-collapse-item__title--expanded {
        .van-icon {
          transform: rotate(90deg);
        }
      }
      .van-tabs__wrap {
        height: 72px!important;
      }
      .van-tab--active {
        color: #AA934D;
        font-weight: 400;
      }
      .van-tabs__line {
        width: 40px;
        background: #AA934D ;
      }
    }
    .item-li {
      padding: 12px 0;
      color: #323233;
      &:first-child {
        padding-top: 24px;
      }
      &:last-child {
        padding-bottom: 24px;
      }
    }
    .h5-sctived-path {
      color: #AA934D
    }
}
</style>
